import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";
import CTABlock from "../components/CTABlock";
import { SEO_META, IMAGES } from "../config/site";

const BLOCKS = [
  { title: "What we manufacture", text: "Uniforms and workwear across healthcare, hospitality, airline and airport, logistics and industrial, corporate, salon and spa, sports teamwear and winter categories — produced to buyer specifications for bulk orders.", img: IMAGES.sewing, alt: "Precision sewing of a professional uniform garment" },
  { title: "How we work", text: "Every program starts with your requirement: style, fabric, colors, branding and quantities. We develop the garment, finalize specifications with you, and move approved styles into scheduled bulk production.", img: IMAGES.fabricMacro, alt: "Fabric and thread detail during uniform construction" },
  { title: "Who we serve", text: "Procurement managers, importers, distributors, hotels, hospitals, airlines, logistics companies, corporate groups, sports organizations, uniform dealers and sourcing companies buying in business volumes.", img: IMAGES.frontdesk, alt: "Hotel front office staff in professional uniforms" },
];

export default function About() {
  const meta = SEO_META.about;
  return (
    <>
      <SEO title={meta.title} description={meta.description} path={meta.path} />
      <section className="border-b border-obsidian/10 bg-bone" data-testid="about-hero">
        <div className="container-site py-16 lg:py-24">
          <Reveal>
            <p className="eyebrow">About Cleef Empire</p>
            <h1 className="mt-4 max-w-3xl font-display text-4xl font-black leading-[1.06] tracking-tight sm:text-5xl">
              Professional uniforms, built around your business.
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-obsidian/60">
              Cleef Empire is a B2B uniform and apparel manufacturer and exporter based in India. We work
              with businesses, institutions and professional teams worldwide — developing and producing
              uniforms that match how their people actually work.
            </p>
            <Link to="/bulk-quote" data-event="bulk_quote_click" data-testid="about-hero-quote-btn" className="btn-primary mt-8">
              Get Bulk Quote <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>

      <div className="container-site py-16 lg:py-24">
        {BLOCKS.map((b, i) => (
          <section key={b.title} className="grid items-center gap-10 border-b border-obsidian/10 py-14 first:pt-0 last:border-0 lg:grid-cols-2 lg:gap-16">
            <Reveal className={i % 2 ? "lg:order-2" : ""}>
              <div className="frame-offset overflow-hidden">
                <img src={b.img} alt={b.alt} loading="lazy" className="aspect-[4/3] w-full object-cover" />
              </div>
            </Reveal>
            <Reveal delay={0.1} className={i % 2 ? "lg:order-1" : ""}>
              <span className="font-mono text-xs font-semibold tracking-[0.2em] text-cleef">0{i + 1}</span>
              <h2 className="mt-3 font-display text-2xl font-extrabold tracking-tight sm:text-3xl">{b.title}</h2>
              <p className="mt-4 max-w-md text-base leading-relaxed text-obsidian/60">{b.text}</p>
            </Reveal>
          </section>
        ))}
      </div>
      <CTABlock />
    </>
  );
}
